import React, { useState } from 'react'
import styled from 'styled-components'
import { history } from '../../../_helpers'

import { createEmptyInvoiceSchedule, updateInvoiceSchedule } from '../../../_services/lender.service'
import ROUTES from '../../../_constants/routes'

import { StandardPage } from '../../../_components/layout/StandardPage'
import { StatList } from '../../../_components/StatList'
import { FormField } from '../../../_components/Forms/FormField'
import { Button } from '../../../_components/Button'

import { useBusiness } from '../../../_reduxHooks/business.hook'
import { S_PageHeader } from '../../../_components/layout/PageHeader/PageHeader.styles'

const S_InvoicesOverview = styled.div`
  .list-wrapper {
    align-items: flex-end;
  }
`

export const ClientInvoiceScheduleCreate = ({ setIsLoading }) => {
  const { business } = useBusiness()
  const [expectedBatchTotal, setExpectedBatchTotal] = useState(0)

  return (
    <S_InvoicesOverview>
      <StandardPage title="Create Schedule">
        <S_PageHeader>
          <Button buttonType="link" className="link" to={ROUTES.client_home}>
            Back to summary
          </Button>
        </S_PageHeader>

        <header className="page-header">
          <h1>Create New Schedule</h1>
        </header>
        <StatList
          items={[
            {
              label: 'Batch Total',
              type: null,
              tooltip: 'Manually enter schedule total to ensure balance is same as auto-calculated schedule total',
              value: (
                <FormField
                  onChange={(numVal) => {
                    setExpectedBatchTotal(numVal)
                  }}
                  type="currency"
                  value={expectedBatchTotal}
                />
              ),
            },
            {
              label: '',
              type: null,
              value: (
                <Button
                  className={`save-client-btn`}
                  onClick={async () => {
                    if (business?.id) {
                      let schedule = await createEmptyInvoiceSchedule(business.id)
                      await updateInvoiceSchedule(schedule.id, {
                        expected_total_value: expectedBatchTotal,
                      })
                      setIsLoading(true)
                      history.push(ROUTES.client_invoice_submission + `/${schedule.id}`)
                    }
                  }}
                >
                  Create
                </Button>
              ),
            },
          ]}
          layout="summary"
        />
      </StandardPage>
    </S_InvoicesOverview>
  )
}
